<template>
  <div class="card">
    <div class="mobileHorizontalLineCard"></div>
    <div class="card__container">
      <div class="top">
        <sc-richText v-if="fields && fields.stat" :field="fields.stat" class="stat" />
        <sc-text v-if="fields && fields.statlabel" :field="fields.statlabel" class="statLabel" />
        <sc-richText
          v-if="fields && fields.description"
          :field="fields.description"
          class="description"
        />
      </div>
      <div class="bottom">
        <sc-image v-if="fields && fields.icon" :media="fields.icon" class="cardIcon" />
        <sc-text v-if="fields && fields.type" :field="fields.type" class="type" />
      </div>
    </div>
  </div>
</template>

<script>
import { Text, RichText, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Healthcare-Graphic-Card',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  position: relative;
  margin: 0 0 3rem 2rem;

  &:last-child {
    margin-bottom: 0;
  }

  @include tablet-up {
    width: calc(100% / 3);
    margin: 0 0 0 3rem;

    &:nth-child(1) {
      margin-left: 0;
    }
  }

  .mobileHorizontalLineCard {
    display: none;

    @include tablet-down {
      display: block;
      position: absolute;
      top: 50%;
      left: -2rem;
      height: 0.1rem;
      width: 0;
      background-color: $divider;
    }
  }

  &__container {
    opacity: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
    padding: 1.4rem 2.4rem 2.4rem 1.6rem;
    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );

    .stat {
      position: relative;
      display: inline-block;
      @include font-styles('Arial Narrow', 5rem, 600, normal, normal, -0.1rem, $white);
      margin-right: 0.8rem;
      margin-bottom: 1.5rem;

      @include tablet-up {
        font-size: 3.5rem;
        line-height: 3.5rem;
      }

      @media (min-width: 1400px) {
        font-size: 5rem;
        line-height: 5rem;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: -1.5rem;
        left: 0;
        height: 0.2rem;
        width: 100%;
        background-color: $orange;

        @include tablet-up {
          bottom: -1rem;
        }

        @include large-desktop-up {
          bottom: -1.5rem;
        }
      }

      &:deep() {
        sup {
          font-size: 2rem;
          vertical-align: super;
          top: -0.2rem;

          @include tablet-up {
            font-size: 1.5rem;
          }

          @include large-desktop-up {
            font-size: 2rem;
          }
        }
      }
    }

    .statLabel {
      position: relative;
      display: inline-block;
      @include font-styles('Arial Narrow', 2.4rem, 400, normal, normal, 0, $white);
      top: -0.5rem;

      @include tablet-up {
        font-size: 1.6rem;
        line-height: 1.6rem;
      }

      @media (min-width: 1400px) {
        font-size: 2.4rem;
        line-height: 2.4rem;
      }
    }

    .description {
      @include font-styles('Arial', 1.6rem, 400, normal, 2.2rem, 0, $white);
      margin-top: 0.8rem;
      margin-bottom: 3rem;

      @include large-desktop-up {
        padding-right: 18%;
      }

      &:deep() {
        p,
        span,
        div {
          @include font-styles(
            'Arial',
            1.6rem !important,
            400,
            normal,
            2.2rem !important,
            normal,
            $white
          );
          margin: 0;
        }
      }
    }

    .bottom {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: flex-end;

      @include tablet-up {
        flex-direction: column;
        align-items: start;
        margin-top: auto;
      }

      @media (min-width: 1400px) {
        flex-direction: row;
        align-items: flex-end;
      }

      img {
        max-width: 100%;
        max-height: max-content;
      }

      .cardIcon {
        opacity: 0;
        position: relative;
        top: 3rem;
      }

      .type {
        @include font-styles('Arial', 1.4rem, 500, normal, 1.8rem, 0, $white);
        margin-top: 1rem;

        @include tablet-up {
          display: block;
          font-size: 1.2rem;
          line-height: 1.6rem;
        }

        @include large-desktop-up {
          font-size: 1.4rem;
        }
      }
    }
  }
}
</style>
